import { FlexBox } from "components/Common/FlexBox"
import { ConfirmBody, ConfirmTitle, IconWrapper, StyledModal } from "./styled"
import TrashIcon from "components/Icons/TrashIcon"
import Button from "components/Buttons/Button"
import InfoIcon from "components/Icons/InfoIcon"
import React from "react"

interface IPopInfoProps {
  isOpen: boolean
  title: string
  onConfirm: () => void
  type?: "danger" | "info" | "modal"
  children: React.ReactNode
  confirmText?: string
}

const PopInfo = (props: IPopInfoProps) => {
  const {
    isOpen,
    title,
    confirmText = "Ok",
    onConfirm,
    type = "info",
    children,
  } = props
  return (
    <StyledModal
      style={
        {
          "--app-max-width": "450px",
          "--horizontal-margin": "48px",
          "--max-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
          "--min-width":
            "calc(min(100vw,var(--app-max-width)) - var(--horizontal-margin))",
        } as React.CSSProperties
      }
      visible={isOpen}
      content={
        <FlexBox $direction="column" $gap={16} style={{ width: "100%" }}>
          <FlexBox $direction="column" $gap={type === "modal" ? 0 : 4}>
            <FlexBox $justify="center">
              {type === "modal" ? undefined : type === "info" ? (
                <IconWrapper $type="info">
                  <InfoIcon />
                </IconWrapper>
              ) : (
                <IconWrapper $type="danger">
                  <TrashIcon color="#FF4921" />
                </IconWrapper>
              )}
            </FlexBox>
            <ConfirmTitle $type={type}>{title}</ConfirmTitle>

            <ConfirmBody $maxLines={3}>{children}</ConfirmBody>
          </FlexBox>

          <FlexBox $gap={16} $justify="center">
            <Button
              style={{ padding: "6px 16px" }}
              onClick={onConfirm}
              $type={type === "danger" ? "danger" : "info"}
              $size="small"
            >
              {confirmText}
            </Button>
          </FlexBox>
        </FlexBox>
      }
    ></StyledModal>
  )
}

export default PopInfo
